export default "__VITE_ASSET__DIByOscM__"